import * as React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory, useParams } from 'react-router-dom'
import { NewsCenterMessengerEventType, NewsCenterTheme, PublicLocale } from '../../types'
import i18next from 'i18next'
import ERoute from '../ERoute'
import Header from '../components/Header/Header'
import Overview from './Overview'
import styled, { createGlobalStyle, css } from 'styled-components'
import News from './News'
import { useDispatch, useSelector } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'
import { AppState } from '../store'
import { overviewLink } from '../helpers/NavigationHelper'
import NewsCenterHelper from '../../helpers/NewsCenterHelper'
import { NewsCenterActionTypes } from '../store/news-center/types'
import { WidgetHelper } from '../../widget/helpers'
import { TooltipProvider } from '@/components/ui/tooltip'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 40px;

  @media screen and (max-width: 767px) {
    padding: 0 20px;
  }
`

const Content = styled.div<{ embedded: boolean }>`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding-top: 36px;
  padding-bottom: 36px;

  ${(props) => props.embedded && css`
    padding: 0;
  `}
`

const GlobalStyle = createGlobalStyle<{ theme: NewsCenterTheme }>`
  body {
    background-color: ${(props) => props.theme.colors.body};
  }

  a {
    color: ${(props) => props.theme.colors.action};
  }
`

interface IProps { }

const App = (props: IProps) => {
  const { currentLocale, newsCenter } = useSelector((state: AppState) => state.newsCenter)
  const dispatch = useDispatch() as Dispatch<AnyAction>
  const embedded = NewsCenterHelper.isEmbedded()

  const onLinkClick = (e) => {
    const target = e.target as HTMLElement

    // Check if clicked element is a link or inside a link
    const link = target.closest('a')


    if (link?.href && !link.href.includes('javascript:')) {
      if (link.href.includes(newsCenter.url)) {
        const url = link.href

        if (WidgetHelper.isDeepLink(url)) {
          e.preventDefault()

          NewsCenterHelper.sendParentMessage({
            type: NewsCenterMessengerEventType.DEEP_LINK,
            url: url
          })
        } else {
          throw new Error(`Unknown deep link format: ${url}`)
        }
      } else {
        e.preventDefault()
        window.open(link.href, '_blank')
      }
    }
  }

  React.useEffect(() => {
    i18next.changeLanguage(currentLocale, (err, t) => { });
  }, [currentLocale])

  React.useEffect(() => {
    const locale = NewsCenterHelper.getLocaleFromUrl()
    const action: NewsCenterActionTypes = { type: 'SET_LOCALE', locale: (locale || newsCenter.locale) as PublicLocale }

    dispatch(action)
  }, [window.location.href])

  React.useEffect(() => {
    if (NewsCenterHelper.isEmbedded()) {
      window.addEventListener('click', onLinkClick)

      return () => {
        window.removeEventListener('click', onLinkClick)
      }
    }

  }, [])

  return (
    <TooltipProvider>
      <Router>
        <GlobalStyle />
        <Header />

        <Wrapper>
          <Content embedded={embedded}>
            <Switch>
              <Route path={ERoute.PATH_NEWS} component={News} />
              <Route path={ERoute.PATH_ROOT} component={Overview} />
              <Redirect to={overviewLink(currentLocale)} />
            </Switch>
          </Content>
        </Wrapper>
      </Router>
    </TooltipProvider>
  )
}

export default App